import { createFileRoute, notFound } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseYearSlug } from "@/lib/calendar/dates";
import { LiburNasionalPage } from "@/components/pages/LiburNasionalPage";
import { getHolidaysForYear } from "@/data/holidays";
import { itemListSchema, breadcrumbSchema, ldScripts } from "@/lib/seo/schema";

export const Route = createFileRoute("/en/public-holidays/$year")({
  loader: ({ params }) => {
    const y = parseYearSlug(params.year);
    if (!y) throw notFound();
    return { y };
  },
  head: ({ loaderData }) => {
    const y = loaderData?.y ?? "";
    const events = typeof y === "number"
      ? getHolidaysForYear(y).filter((h) => h.type === "libur").map((h) => ({
          name: h.name, date: h.date, description: `Indonesian public holiday ${y}.`,
          url: `/en/public-holidays/${y}`,
        }))
      : [];
    return {
      meta: [
        { title: `Indonesian Public Holidays ${y} - Official SKB List` },
        { name: "description", content: `Complete list of Indonesian public holidays for ${y} based on the Joint Ministerial Decree (SKB 3 Menteri).` },
        { property: "og:title", content: `Public Holidays Indonesia ${y}` },
        { property: "og:description", content: `Official Indonesian public holidays ${y}.` },
      ],
      links: [{ rel: "canonical", href: `https://hari.co.id/en/public-holidays/${y}/` }],
      scripts: typeof y === "number" ? ldScripts([
        breadcrumbSchema([
          { name: "Home", url: "/en" },
          { name: `${y}`, url: `/en/${y}` },
          { name: `Public Holidays ${y}`, url: `/en/public-holidays/${y}` },
        ]),
        events.length > 0 ? itemListSchema(events, "en") : null,
      ].filter(Boolean) as unknown[]) : [],
    };
  },
  component: () => {
    const { y } = Route.useLoaderData();
    return <LiburNasionalPage y={y} locale="en" />;
  },
  notFoundComponent: () => (
    <SiteShell locale="en"><div className="py-16 text-center"><h1 className="text-2xl font-bold">Invalid year</h1></div></SiteShell>
  ),
});